var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mdc-form-field mdc-switch-container" }, [
    _c(
      "label",
      {
        staticClass:
          "mdc-switch-label typography--body-3 typography--color-secondary clickable",
        attrs: { for: _vm.id }
      },
      [_vm._t("label")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mdc-switch" }, [
      _c("input", {
        staticClass: "mdc-switch__native-control",
        attrs: { type: "checkbox", id: _vm.id },
        domProps: { checked: _vm.state },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mdc-switch__background" }, [
      _c("div", { staticClass: "mdc-switch__knob" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8babe050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8babe050","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleSwitch.vue
// module id = JDL/
// module chunks = 1